import dynamic from 'next/dynamic'

export default dynamic(() => import('./index'), {
  ssr: false,
  loading: () => null,
})
